export default [
  {
    path: '/dictionary',
    name: 'dictionary',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/DictionaryList.vue'),
    meta: {},
  },
  // Quyết định thi hành án
  {
    path: '/dictionary/justiceDecision',
    name: 'justiceDecision',
    component: () => import('@/views/dictionary/justiceDecision/JusticeDecisionList.vue'),
  },
  // Nhóm quyết định thi hành án
  {
    path: '/dictionary/justiceDecisionGroup',
    name: 'justiceDecisionGroup',
    component: () => import('@/views/dictionary/justiceDecisionGroup/JusticeDecisionGroupList.vue'),
  },
  // Bản án
  {
    path: '/dictionary/justicecase',
    name: 'justiceCase',
    component: () => import('@/views/dictionary/justiceCase/JusticeCaseList.vue'),
  },
  // Loại bản án
  {
    path: '/dictionary/justicecasetype',
    name: 'justiceCaseType',
    component: () => import('@/views/dictionary/justiceCaseType/JusticeCaseTypeList.vue'),
  },
  // Danh mục nhóm tài khoản
  {
    path: '/dictionary/accountcategory',
    name: 'accountcategory',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountCategory/AccountCategoryList.vue'),
    meta: {},
  },

  // Danh mục Tiền tệ
  {
    path: '/dictionary/currency',
    name: 'currency',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/currency/CurrencyList.vue'),
    meta: {},
  },

  // Danh mục Tài sản/tang vật
  {
    path: '/dictionary/asset',
    name: 'asset',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/asset/AssetList.vue'),
    meta: {},
  },
  // Loại tài sản/tang vật
  {
    path: '/dictionary/assetcategory',
    name: 'assetcategory',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/assetCategory/AssetCategoryList.vue'),
    meta: {},
  },
  // Mẫu số biên lai
  {
    path: '/dictionary/receipt',
    name: 'receipt',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/receipt/ReceiptList.vue'),
    meta: {},
  },
  // Mã thống kê
  {
    path: '/dictionary/listcode',
    name: 'listcode',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/listCode/ListCodeList.vue'),
    meta: {},
  },

  // Danh sách đối tượng
  {
    path: '/dictionary/accountingobject',
    name: 'accountingobject',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountingObject/AccountingObject.vue'),
  },
  // Chấp hành viên
  {
    path: '/dictionary/bailiffs',
    name: 'bailiffs',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/bailiffs/BailiffsList.vue'),
  },
  // Đối tượng phải thi hành án
  {
    path: '/dictionary/excutionobject',
    name: 'excutionobject',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/excutionObject/ExcutionObjectList.vue'),
  },
  // Đối tượng được thi hành án
  {
    path: '/dictionary/excutedobject',
    name: 'excutedobject',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/excutedObject/ExcutedObjectList.vue'),
  },
  // Nhà cung cấp
  {
    path: '/dictionary/supplier',
    name: 'supplier',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/supplier/SupplierList.vue'),
  },
  // Ủy ban nhân dân
  {
    path: '/dictionary/peoplecommitee',
    name: 'peoplecommitee',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/peopleCommitee/PeopleCommiteeList.vue'),
  },
  // Đối tượng khác
  {
    path: '/dictionary/objectdifferent',
    name: 'objectdifferent',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/objectDifferent/ObjectDifferentList.vue'),
  },
  // Đơn vị trực thuộc
  {
    path: '/dictionary/branch',
    name: 'branch',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/branch/BranchList.vue'),
    meta: {},
  },
  // Khu vực
  {
    path: '/dictionary/area',
    name: 'area',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/area/AreaList.vue'),
    meta: {},
  },
  // Hệ thống tài khoản
  {
    path: '/dictionary/accounts',
    name: 'accounts',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/systemAccounts/AccountsList.vue'),
    meta: {},
  },
  // Danh mục kho
  {
    path: '/dictionary/stock',
    name: 'stock',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/stock/StockList.vue'),
    meta: {},
  },
  // Danh mục ngân hàng/kho bạc
  {
    path: '/dictionary/bankstandard',
    name: 'bankstandard',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/bankStandard/BankStandardList.vue'),
    meta: {},
  },
  // Tài khoản ngân hàng
  {
    path: '/dictionary/bankinfo',
    name: 'bankinfo',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/bankInfo/BankInfoList.vue'),
    meta: {},
  },
  // Tài khoản kết chuyển
  {
    path: '/dictionary/accountTransfer',
    name: 'accountTransfer',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountTransfer/AccountTransferList.vue'),
    meta: {},
  },
  // Tài khoản ngầm định
  {
    path: '/dictionary/defaultAccount',
    name: 'defaultAccount',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/defaultAccount/DefaultAccountList.vue'),
    meta: {},
  },
  // Thay đổi chấp hành viên
  {
    path: 'changeObject',
    name: 'changeObject',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/changeObject/ChangeObject.vue'),
    meta: {},
  },
  // Chuyển CHV theo dõi QĐ THA
  {
    path: 'transferExecutor',
    name: 'transferExecutor',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/transferExecutor/TransferExecutor.vue'),
    meta: {},
  },
  // kiểm tra tính hợp lệ của số dư ban đầu
  {
    path: 'checkValidAmount',
    name: 'checkValidAmount',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/checkValidAmount/CheckValidAmount.vue'),
    meta: {},
  },
  // kiểm tra tính hợp lệ của chứng từ
  {
    path: 'checkValidVoucher',
    name: 'checkValidVoucher',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/checkValidVoucher/CheckValidVoucher.vue'),
    meta: {},
  },

  {
    path: 'importChequeIssue',
    name: 'importChequeIssue',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/importChequeIssue/ImportChequeIssue.vue'),
    meta: {},
  },
];
